import { get } from 'svelte/store';
import { t } from 'svelte-i18n';

export enum OperationSectorPrefEnum {
	SANTE = 'SANTE',
	ENVIRONNEMENT = 'ENVIRONNEMENT',
	IMMOBILIER = 'IMMOBILIER'
}

export enum OperationCollectEnum {
	IMPACT_HOMME = 'IMPACT_HOMME',
	IMPACT_NATURE = 'IMPACT_NATURE',
	IMMOBILIER = 'IMMOBILIER'
}

export enum OperationCategoryEnumFR {
	SANTE = 'SANTE',
	IMPACT_NATURE = 'IMPACT_NATURE',
	IMMOBILIER = 'IMMOBILIER',
	EPARGNE_OCCITANIE = 'EPARGNE_OCCITANIE',
	FONDS = 'FONDS',
	TECH_INNOVATION = 'TECH_INNOVATION',
	ENERGIES_RENOUVELABLES = 'ENERGIES_RENOUVELABLES'
}

export enum OperationCategoryEnum {
	HEALTH = 'HEALTH',
	ENERGY_TRANSITION = 'ENERGY_TRANSITION',
	REAL_ESTATE = 'REAL_ESTATE',
	OCCITAN_SAVINGS = 'OCCITAN_SAVINGS',
	FUNDS = 'FUNDS',
	TECH_AND_INNOVATION = 'TECH_AND_INNOVATION',
	RENEWABLE_ENERGIES = 'RENEWABLE_ENERGIES'
}

export const getOperationCategoryFromFR = (
	e: OperationCategoryEnumFR
): OperationCategoryEnum | undefined => {
	let category;

	switch (e.toString()) {
		case 'SANTE':
			category = OperationCategoryEnum.HEALTH;
			break;
		case 'IMPACT_NATURE':
			category = OperationCategoryEnum.ENERGY_TRANSITION;
			break;
		case 'IMMOBILIER':
			category = OperationCategoryEnum.REAL_ESTATE;
			break;
		case 'FONDS':
			category = OperationCategoryEnum.FUNDS;
			break;
		case 'EPARGNE_OCCITANIE':
			category = OperationCategoryEnum.OCCITAN_SAVINGS;
			break;
		case 'TECH_INNOVATION':
			category = OperationCategoryEnum.TECH_AND_INNOVATION;
			break;
		case 'ENERGIES_RENOUVELABLES':
			category = OperationCategoryEnum.RENEWABLE_ENERGIES;
			break;
	}
	return category;
};

export const getOperationSectorFromEN = (
	e: OperationCategoryEnum
): OperationCategoryEnumFR | undefined => {
	switch (e) {
		case OperationCategoryEnum.HEALTH:
			return OperationCategoryEnumFR.SANTE;
		case OperationCategoryEnum.ENERGY_TRANSITION:
			return OperationCategoryEnumFR.IMPACT_NATURE;
		case OperationCategoryEnum.REAL_ESTATE:
			return OperationCategoryEnumFR.IMMOBILIER;
		case OperationCategoryEnum.OCCITAN_SAVINGS:
			return OperationCategoryEnumFR.EPARGNE_OCCITANIE;
		case OperationCategoryEnum.FUNDS:
			return OperationCategoryEnumFR.FONDS;
		case OperationCategoryEnum.TECH_AND_INNOVATION:
			return OperationCategoryEnumFR.TECH_INNOVATION;
	}
};

export const getOperationSectorArrayFromFR = (
	a: OperationCategoryEnumFR[]
): OperationCategoryEnum[] => {
	const sectorEnums: OperationCategoryEnum[] = [];
	a.forEach((e) => {
		sectorEnums.push(getOperationCategoryFromFR(e));
	});
	return sectorEnums;
};

export const getOperationCategoryString = (e: OperationCategoryEnum): string => {
	const $t = get(t);
	switch (e) {
		case OperationCategoryEnum.HEALTH:
			return $t('sector.health');
		case OperationCategoryEnum.ENERGY_TRANSITION:
			return $t('sector.energyTransition');
		case OperationCategoryEnum.REAL_ESTATE:
			return $t('sector.realEstate');
		case OperationCategoryEnum.OCCITAN_SAVINGS:
			return $t('sector.occitanSavings');
		case OperationCategoryEnum.FUNDS:
			return $t('sector.funds');
		case OperationCategoryEnum.TECH_AND_INNOVATION:
			return $t('sector.techAndInnovation');
		case OperationCategoryEnum.RENEWABLE_ENERGIES:
			return $t('sector.renewableEnergy');
		default:
			return '';
	}
};

export const getOperationCategoryFromStoryBlock = (e: string): OperationCategoryEnum => {
	switch (e) {
		case 'health':
			return OperationCategoryEnum.HEALTH;
		case 'energy-transition':
			return OperationCategoryEnum.ENERGY_TRANSITION;
		case 'real-estate':
			return OperationCategoryEnum.REAL_ESTATE;
		case 'occitan-savings':
			return OperationCategoryEnum.OCCITAN_SAVINGS;
		case 'funds':
			return OperationCategoryEnum.FUNDS;
		case 'tech-and-innovation':
			return OperationCategoryEnum.TECH_AND_INNOVATION;
		default:
			return OperationCategoryEnum.REAL_ESTATE;
	}
};
